import React from "react";
import { skills } from "../../data/skills";

const SkillsSection = () => {
  return (
    <section className="bg-gray-900 bg-opacity-0 text-white px-6 py-12">
      <div className="max-w-5xl mx-auto text-center">
        <h2 className="text-3xl font-bold mb-6">Skills & Tools</h2>
        <div className="flex flex-wrap justify-center gap-4">
          {skills[0].skillSet.map((skill, index) => {
            const icon = skills[0].skillIcons[index];
            return (
              <span
                key={index}
                className="flex items-center gap-2 bg-gray-900 text-orange-400 border border-orange-400 px-4 py-2 rounded-full text-sm font-medium hover:bg-orange-400 hover:text-black transition duration-200"
              >
                {skill}
                {icon && <img src={icon} alt={`${skill} icon`} className="w-5 h-5" />}
              </span>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
